import React from 'react';
import { IconButton } from '@mui/material';
import { IconArrowRightSolid } from '@roku-web-ui/rds-icons';
import { useNavigate } from '@tanstack/react-router';
import { colors } from '@roku-web-ui/rds-theme';

import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';

interface NextEventProps {
  nextEventId: string;
  currentEventId: string;
}

export const NextEvent = ({ nextEventId, currentEventId }: NextEventProps) => {
  const navigate = useNavigate();
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title="Next event" placement="top">
      <IconButton
        aria-label="next-event"
        data-testid="button-next-event"
        onClick={() => {
          logAspenEvent({
            log_id: 'iot.web.event.interaction',
            payload: {
              event_id: currentEventId,
              target_event_id: nextEventId,
              interaction: 'next_event',
            },
          });

          navigate({
            to: '/events',
            search: {
              eventId: nextEventId,
            },
          });
        }}
        sx={{
          '&.MuiIconButton-root': {
            padding: '0', // Override RDS padding
          },
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconArrowRightSolid sx={{ color: colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
